import { SvgComponent } from './SvgComponent';
import { IconProps } from './types';

const PictureOutline = ({
  width = 60,
  height = 60,
  color = '#E1E1E3',
  ...props
}: IconProps) => (
  <SvgComponent width={width}
    height={height}
    viewBox='0 0 60 60' // Ensures the SVG scales correctly with the given width and height
    {...props}
  >
    <path
      d='M47.5519 5.10986C51.6756 5.10986 55.0185 8.45277 55.0185 12.5765V47.4206C55.0185 51.5443 51.6756 54.8872 47.5519 54.8872H12.7078C8.58412 54.8872 5.24121 51.5443 5.24121 47.4206V12.5765C5.24121 8.45277 8.58412 5.10986 12.7078 5.10986H47.5519ZM47.5519 8.84316H12.7078C10.7196 8.84316 9.0944 10.3974 8.98085 12.3571L8.97451 12.5765V47.4206C8.97451 49.4088 10.5287 51.034 12.4885 51.1476L12.7078 51.1539H47.5519C49.5402 51.1539 51.1654 49.5997 51.2789 47.64L51.2852 47.4206V46.5893L41.057 36.3608C40.1872 35.4911 38.8016 35.4515 37.8849 36.2422L37.7572 36.3608L21.72 52.3971H16.4411L35.8873 32.9511C37.8313 31.0071 40.983 31.0071 42.9269 32.9511L50.4355 40.4595C50.6299 40.6539 50.9451 40.6538 51.1395 40.4594C51.2328 40.3661 51.2852 40.2395 51.2852 40.1075V12.5765C51.2852 10.5883 49.731 8.96305 47.7713 8.8495L47.5519 8.84316Z'
      fill='#E1E1E3'
    />
    <path
      d='M20.1743 15.0654C23.6107 15.0654 26.3965 17.8512 26.3965 21.2876C26.3965 24.724 23.6107 27.5098 20.1743 27.5098C16.7379 27.5098 13.9521 24.724 13.9521 21.2876C13.9521 17.8512 16.7379 15.0654 20.1743 15.0654ZM20.1743 18.7987C18.7998 18.7987 17.6854 19.913 17.6854 21.2876C17.6854 22.6622 18.7998 23.7765 20.1743 23.7765C21.5489 23.7765 22.6632 22.6622 22.6632 21.2876C22.6632 19.913 21.5489 18.7987 20.1743 18.7987Z'
      fill='#E1E1E3'
    />
  </SvgComponent>
);

export default PictureOutline;
